/**
 * @generated SignedSource<<0a63fb81c928f9cfe5ac5c7a661aec6b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContemporaryLandingFurnitureTileModule_contemporaryLandingRow$data = {
  readonly items: ReadonlyArray<{
    readonly caption?: string | null;
    readonly cta?: string | null;
    readonly imagePath?: string | null;
    readonly linkData?: {
      readonly " $fragmentSpreads": FragmentRefs<"SeoButton_linkData">;
    };
  } | null> | null;
  readonly " $fragmentType": "ContemporaryLandingFurnitureTileModule_contemporaryLandingRow";
};
export type ContemporaryLandingFurnitureTileModule_contemporaryLandingRow$key = {
  readonly " $data"?: ContemporaryLandingFurnitureTileModule_contemporaryLandingRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContemporaryLandingFurnitureTileModule_contemporaryLandingRow">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContemporaryLandingFurnitureTileModule_contemporaryLandingRow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "caption",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cta",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imagePath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "linkData",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SeoButton_linkData"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ContemporaryLandingFurnitureTileSection",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContemporaryLandingRow",
  "abstractKey": null
};

(node as any).hash = "9f07aff068bb2efea996dd43e94aeb0a";

export default node;
